import { render, staticRenderFns } from "./TwoColumns.vue?vue&type=template&id=202dec3c"
import script from "./TwoColumns.vue?vue&type=script&lang=js"
export * from "./TwoColumns.vue?vue&type=script&lang=js"
import style0 from "./TwoColumns.vue?vue&type=style&index=0&id=202dec3c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports